<div #chart class="gauge-chart"></div>
